import(/* webpackMode: "eager" */ "/home/interim/frontend/app/events/page.tsx");
